export default "__VITE_ASSET__rbP48uae__"